export type ServiceProbeStatus = 'up' | 'down' | string;
export type OverallStatus = 'ok' | 'degraded' | 'down' | string;

export interface HealthLiveness {
  status: OverallStatus;
}

export interface HealthService {
  id: string;
  url: string;
  status: ServiceProbeStatus;
  http_status: number | null;
  latency_ms: number;
  error: string | null;
  required: boolean;
}

export interface HealthStatusResponse {
  status: OverallStatus;
  mode: string;
  checked_at: string;
  services: HealthService[];
}

export interface ServiceSnapshot {
  status: ServiceProbeStatus;
  latency_ms: number;
}

export interface PollSnapshot {
  at: number;
  overall: OverallStatus;
  up: number;
  down: number;
  requiredUp: number;
  requiredDown: number;
  optionalDown: number;
  avgLatency: number;
  byService: Record<string, ServiceSnapshot>;
}

export const LIVE_STORAGE_KEY = 'portal_health_live';
export const INTERVAL_STORAGE_KEY = 'portal_health_interval_sec';
export const INTERVAL_OPTIONS = [5, 10, 15, 30, 60] as const;
export type IntervalSeconds = (typeof INTERVAL_OPTIONS)[number];
export const HISTORY_CAP = 60;
export const DEFAULT_INTERVAL: IntervalSeconds = 10;
